import { DataApi } from "../../api";

const usehook = () => {

    const getAllFaqs = async ()=>{
        try {
            const response = await DataApi.getFaqs()
            return response.data.data;
        } catch (error) {
            
        }

    }
    return{
        getAllFaqs,
    }
}

export default usehook
